import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DashboardResponse } from '../contracts/dashboard.interface';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private url = 'dashboard/';

  constructor(private http: HttpClient) {}

  getDashboard(dateFrom: string, dateTo: string, operatorIds?: number[]): Observable<DashboardResponse> {
    let params = new HttpParams()
      .set('dateFrom', dateFrom)
      .set('dateTo', dateTo);

    if (operatorIds && operatorIds.length > 0) {
      operatorIds.forEach(id => {
        params = params.append('operatorIds', id.toString());
      });
    }

    return this.http.get<DashboardResponse>(this.url, { params });
  }
}
